import React, { useEffect } from 'react';
import useScheduleTable from '../RoomScheduleTable/useScheduleTable';
import { IMeetingOrderFn, IMeetingOrderForm } from 'type/meeting';
import { IMeetingDetail } from 'type/meetingDetail';
import { cloneDeep } from 'lodash-es';
import styles from './index.module.scss';
import UploadSDK from 'lib/upload';
import { TaskOptions } from '@isp/upload-sdk/dist/types/type';

interface IProps {
  /** 标题 */
  title: string;
  /** 小标题 */
  subTitle?: string;
  /** 默认表单参数 */
  formValue?: Partial<IMeetingOrderForm> | null;
  /** 会议详情 */
  meetingDetail?: IMeetingDetail | null;
  /** 确认按钮文案 */
  confirmText?: string;
  /** 表单类型 */
  formType: 'order' | 'edit';
  onConfirm: IMeetingOrderFn;
  onCancel: () => void;
}

interface MeetingOrderFormRef {
  formValue?: Partial<IMeetingOrderForm>;
  formType?: 'order' | 'edit';
  meetingDetail?: IMeetingDetail;
  uploadFile: (option: TaskOptions) => { cancelTask: () => void };
}

const MeetingOrderForm: React.FC<IProps> = ({ title, subTitle, formType, formValue, meetingDetail, onConfirm, onCancel, confirmText }) => {
  const { componentRef } = useScheduleTable<MeetingOrderFormRef>();

  const onUploadFile = (fileOption: TaskOptions) => {
    return UploadSDK.addTask(fileOption);
  };

  /** 创建会议下 —— 设置表单默认值 */
  useEffect(() => {
    if (!componentRef.current || !formValue) return;
    componentRef.current.formValue = cloneDeep(formValue);
  }, [formValue]);

  /** 编辑模式 —— 会议详情数据转换成表单值 */
  useEffect(() => {
    if (!componentRef.current || !meetingDetail) return;
    componentRef.current.meetingDetail = cloneDeep(meetingDetail);
  }, [meetingDetail]);

  /** 属性设置 */
  useEffect(() => {
    if (!componentRef.current) return;
    componentRef.current.confirm = onConfirm;
    componentRef.current.cancel = onCancel;
    componentRef.current.uploadFile = onUploadFile;
    componentRef.current.filterPlaceholder = '搜索成员、部门、最近会议';
    componentRef.current.nodeOrder = 'teamFirst';
  }, []);

  return (
    <>
      <div className={styles.MeetingOrderForm}>
        <div className={styles.titleWrapper}>
          <span className={styles.title}>{title}</span>
          {subTitle && (
            <>
              <span className={styles.separator}> | </span>
              <span className={styles.subTitle}> {subTitle}</span>
            </>
          )}
        </div>
        <ce-meeting-order theme="client" form-type={formType} confirm-text={confirmText} ref={componentRef} />
      </div>
    </>
  );
};

export default MeetingOrderForm;
